import React from 'react';
import useMonitoringSocket from '../hooks/useMonitoringSocket';
import ConnectionList from '../components/monitoring/ConnectionList';
import PageLayout from '../components/PageLayout';

const MonitoringPage = () => {
  const { connections, isConnected } = useMonitoringSocket();

  return (
    <PageLayout>
      <div className="container mx-auto p-4">
        <h1 className="text-2xl font-bold mb-4">Real-time Connection Monitoring</h1>
        <div className="mb-4">
          <strong>Connection Status:</strong>
          <span className={`ml-2 font-semibold ${isConnected ? 'text-green-500' : 'text-red-500'}`}>
            {isConnected ? 'Connected' : 'Disconnected'}
          </span>
        </div>
        <ConnectionList connections={connections} />
      </div>
    </PageLayout>
  );
};

export default MonitoringPage;
